<template>
  <div class="content-item tx-dealersearch module-dealersearch-list">
    <div class="dealersearch-list__wrapper">
      <div class="dealersearch__content">
        <div :class="{'section-row -padded-wide': !mobile}">
          <div :class="{'col-wrapper l-1col': !mobile}">
            <div :class="{'col -indent-left-b2-1-0': !mobile}">
              <DealersearchHeading />
              <GoogleAutocomplete
                v-if="googleReady"
                placeholder=""
                :location="location"
                @place-changed="setLocation($event)"/>
              <SearchResults
                v-if="!showMapOverlay"
                @mouseenter-result="hoveredPoiIndex = $event"
                @mouseleave-result="hoveredPoiIndex = -1"
                :clickedPoiIndex="clickedPoiIndex" />
              <GoogleMap
                v-if="googleReady && mobile && showMapOverlay"
                :hoveredPoiIndex="hoveredPoiIndex"
                :clickedPoiIndex="clickedPoiIndex"
                @clickedPoiIndex="clickedPoiIndex = $event"
                @closedPoiIndex="clickedPoiIndex = -1" />
            </div>
          </div>
        </div>
      </div>
      <div class="dealersearch__map" v-if="!mobile">
        <GoogleMap
          v-if="googleReady"
          :hoveredPoiIndex="hoveredPoiIndex"
          :clickedPoiIndex="clickedPoiIndex"
          @clickedPoiIndex="clickedPoiIndex = $event"
          @closedPoiIndex="clickedPoiIndex = -1" />
      </div>
    </div>
    <div v-if="mobile && !showMapOverlay" class="dealersearch__map-button">
      <div class="btn -btn-accent" @click="showMapOverlay=true">
        <span class="icon-location-after">{{ $t('dealersearch.map.overlay.map') }}</span>
      </div>
    </div>
    <div v-if="mobile && showMapOverlay" class="dealersearch__map-overlay">
      <div class="btn -btn-accent" @click="showMapOverlay=false">
        <span class="icon-book-after">{{ $t('dealersearch.map.overlay.exit') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { mapActions, mapState } from 'vuex'
import DealersearchHeading from '@/components/DealersearchHeading'
import GoogleAutocomplete from '@/components/GoogleAutocomplete'
import SearchResults from '@/components/SearchResults'
import GoogleMap from '@/components/GoogleMap'

export default {
  name: 'App',
  components: {
    DealersearchHeading,
    GoogleAutocomplete,
    GoogleMap,
    SearchResults
  },
  computed: {
    ...mapState({
      location: state => state.location
    })
  },
  provide () {
    return {
      mobile: computed(() => this.mobile),
      phone: computed(() => this.phone)
    }
  },
  data () {
    return {
      googleReady: false,
      mobile: false,
      phone: false,
      showMapOverlay: false,
      hoveredPoiIndex: -1,
      clickedPoiIndex: -1
    }
  },
  methods: {
    ...mapActions([
      'init',
      'filter',
      'updateLocation'
    ]),
    setBreakpoint () {
      this.mobile = window.innerWidth < 1024
    },
    setLocation (place) {
      this.updateLocation(place)
      if (place.location) this.filter()
    },
    filterDealers () {
      this.filter()
    },
    waitForGoogle () {
      const start = Date.now()
      const tick = () => {
        if (window.google && window.google.maps) {
          this.googleReady = true
          return
        }
        // timeout 10s
        if (Date.now() - start < 10000) requestAnimationFrame(tick)
      }
      tick()
    }
  },
  created () {
    // Provide global variables
    this.phone = /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(navigator.userAgent)
    this.setBreakpoint() // sets variable mobile true/false
    window.addEventListener('resize', this.setBreakpoint)

    // Set filter params from querystring
    const url = new URL(window.location.href)
    if (url.searchParams.has('location-name')) {
      this.$store.commit('setLocation', url.searchParams.get('location-name'))
    }
    if (url.searchParams.has('lat') && url.searchParams.has('lng')) {
      this.$store.commit('setLatitude', url.searchParams.get('lat'))
      this.$store.commit('setLongitude', url.searchParams.get('lng'))
    }

    // Load initial data
    this.waitForGoogle()
    this.init()
  }
}
</script>
